import api from '@services/interceptor';
import { useWorkspaceStore } from '@stores/WorkspaceData';
class MapService {
  constructor(){
    this.wp = undefined
  }
  async GetTrace(id) {
    try {
      if(!this.wp)this.wp = await useWorkspaceStore()
      const response = await api.post(`/api/sat/${this.wp.wpid}/${id}/trajectory`);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }
  async GetAllTrace() {
    try {
      if(!this.wp)this.wp = await useWorkspaceStore()
      const response = await api.get(`/api/sat/${this.wp.wpid}/trajectory`);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }
}

export const mapService = new MapService();